import React, {Component} from 'react';

class Odd extends Component {
  render() {
    const current = parseFloat(this.props.odd.c.replace(',', '.'), 10); // current
    // const prev = this.props.odd.p !== null ? parseFloat(this.props.odd.p.replace(',', '.'), 10) : current; // previous

    if (!current) {
      return <span>-</span>;
    }

    // const indicator = current > prev
    //   ? (<i className="fa fa-caret-up"></i>)
    //   : (prev === current)
    //     ? null
    //     : (<i className="fa fa-caret-down"></i>);

    return (
      <span>
        {/*{indicator}*/}
        {current.toFixed(2)}
      </span>
    )
  }
};

export default Odd;


// WEBPACK FOOTER //
// ./src/Components/Odd.js